import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiDelete, apiGet, apiPost } from './api';
import { IAssignResponsibleDto, IResponsibleUserData } from '../types/responsibleUser.types';
const { REACT_APP_SUBSCRIPTION } = process.env;

export const deleteLogisticResponsibleUser = async (responsibleId: number): Promise<IAssignResponsibleDto> => {
  return apiDelete<AxiosRequestConfig, IAssignResponsibleDto>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service-responsible/${responsibleId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const assignLogisticResponsibleUser = async (body: IAssignResponsibleDto): Promise<IAssignResponsibleDto> => {
  return apiPost<AxiosRequestConfig, IAssignResponsibleDto>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service-responsible`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const deleteOrderResponsibleUser = async (responsibleId: number): Promise<IAssignResponsibleDto> => {
  return apiDelete<AxiosRequestConfig, IAssignResponsibleDto>(
    `${REACT_APP_SUBSCRIPTION}/order-responsible/${responsibleId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const assignOrderResponsibleUser = async (body: IAssignResponsibleDto): Promise<IResponsibleUserData> => {
  return apiPost<AxiosRequestConfig, IAssignResponsibleDto>(`${REACT_APP_SUBSCRIPTION}/order-responsible`, body)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLogisticResponsibleUsersList = async (
  orderOrLogisticServiceId: number
): Promise<IResponsibleUserData[]> => {
  return apiGet<AxiosRequestConfig, IResponsibleUserData[]>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service-responsible/${orderOrLogisticServiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrderResponsibleUsersList = async (orderId: number): Promise<IResponsibleUserData[]> => {
  return apiGet<AxiosRequestConfig, IResponsibleUserData[]>(`${REACT_APP_SUBSCRIPTION}/order-responsible/${orderId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
